<template>
  <v-footer absolute flat class="footer-container d-flex flex-column align-start">
    <div class="d-flex justify-center footer-head">
      <LogoButton to="/" :width="220" />
      <div class="font-weight-bold">
        <p class="mt-5">〒542-8691 大阪府大阪市中央区島之内1-14-19</p>
        <p class="mt-1">TEL 06-6252-5510 / FAX 06-6252-5108</p>
      </div>
    </div>
    <div class="footer-foot footer-nav d-flex flex-column justify-center">
<!--
      <ul class="footer-nav d-flex justify-center font-weight-medium">
        <li>
          <v-btn
          variant="text"
          :ripple="false"
          >プライバシーポリシー</v-btn>
        </li>
        <li>
-->
        <v-btn
          variant="text"
          @click="clickContactUs"
          :ripple="false"
          >お問い合わせ</v-btn>
<!--
        </li>
      </ul>
-->
      <div class="footer-copyright d-flex justify-center">

        TradeMark (TM) & COPYRIGHT (C) OKASHOP All Rights Reserved.
      </div>
    </div>

  </v-footer>
  <!-- お問い合わせダイアログ -->
  <ContactUsDialog
    v-model:open="openContactUsDialog"
    @success="successContactUsDialog"
    @cancel="cancelContactUsDialog" />
</template>

<script setup lang="ts">
import LogoButton from '@/components/molecules/buttons/LogoButton.vue'
import ContactUsDialog from '@/components/organisms/dialogs/00000_ContactUsDialog.vue'
import { ref } from 'vue'
// お問い合わせダイアログの開閉
const openContactUsDialog = ref<boolean>(false)

const cancelContactUsDialog = ():void => {
  openContactUsDialog.value = false
}

const successContactUsDialog = () => {
  cancelContactUsDialog()
}

const clickContactUs = ():void => {
  openContactUsDialog.value = true
}
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.footer {
  &-container {
    position: relative;
    background-color: rgb(var(--v-theme-green-02));
    box-sizing: border-box;
    border-radius: 50px 50px 0 0;
    z-index: 0;
    max-height: 224px;
    padding: 0;
    margin-top: 54px;

    // 不規則な破線の疑似要素
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 532px;
      aspect-ratio: calc(532/174);
      background: url("@/assets/footer_left_bg.png") no-repeat;
      background-size: contain;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 532px;
      aspect-ratio: calc(532/174);
      background: url("@/assets/footer_right_bg.png") no-repeat;
      background-size: contain;
    }
  }

  &-head {
    z-index: 1;
    gap: 50px;
    padding-top: 30px;
    margin: 0 auto;
    border-top: 4px solid #000;
  }

  &-foot {
    width: 100%;
    border-left: 4px solid #000;
    border-right: 4px solid #000;
    margin-top: -2px;
  }

  &-nav {
    line-height: 1;
    list-style: none;
    margin-top: 30px;

    li:first-child {
      border-right: 1px solid rgb(var(--v-theme-black));
    }
  }

  &-companyName {
    font-size: 18px;
  }

  &-copyright {
    margin-top: 30px;
    font-size: 12px;
    padding-bottom: 10px;
  }
}
.v-btn {
  background-color: transparent;
  &::v-deep(.v-btn__overlay) {
    display: none;
  }
  &.v-btn--density-default {
    height: 20px;
  }
}
</style>
